import gql from 'graphql-tag';

const UPDATE_TAGS_DEVICE = gql`
  mutation Mutation($deviceSerialNo: String!, $tags: [String]) {
    updateTags(deviceSerialNo: $deviceSerialNo, tags: $tags) {
      code
    }
  }
`;

export default UPDATE_TAGS_DEVICE;
